import { Core } from 'managers';

const getLiteral = (literal, params = []) => {
    const { literals } = Core.store.getState().literal;
    let result = literal;

    if (literals && Object.prototype.hasOwnProperty.call(literals, literal)) {
        result = literals[literal];
    }
    if (literals && literal && !Object.prototype.hasOwnProperty.call(literals, literal)) {
        Core.literalsManager.reportLiteral(literal);
        return literal;
    }

    if (params && params.length > 0 && result) {
        result = result.replace(/%([0-9]+)\$s/g, '%@');
        if (result.includes('%@')) {
            const appearances = result.match(new RegExp('%@', 'g')).length;
            for (let i = 0; i < appearances && i < params.length; i += 1) {
                result = result.replace('%@', params[i]);
            }
        }
    }

    return result;
};

export { getLiteral as t };
